module.exports = "<script type=\"text/html\" id=\"survey-timerpanel\">\n    <div data-bind=\"css: css.timerRoot, text:timerModel.text\"></div>\n</script>\n";